import IndigoApi from '../communication/IndigoApi';
import { Store } from 'redux';
import State from 'store/State';
import { LoggingService } from '@instinet-analytics/core-lib';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { addAvailabilityStatus } from 'app/store/connectivity/connectivityStateSlice';

export interface AvailabilityStatusServiceOptions {
    indigoApi: IndigoApi;
    loggingService: LoggingService;
}

/*
 * Monitors the AvailabilityStatus and updates state if it drops
 */
export class AvailabilityStatusService {
    private indigoApi: IndigoApi;
    private logger: Logger;
    public store: Store<State> | undefined;

    public constructor(options: AvailabilityStatusServiceOptions) {
        this.indigoApi = options.indigoApi;
        this.logger = buildLogger(
            'AvailabilityStatusService',
            options.loggingService
        );
        this.indigoApi.subscribeAvailabilityStatusChange(
            (status: { availabilityStatus: string; available: boolean }) =>
                this.onAvailabilityStatusStatusChange(status)
        );
    }

    public onAvailabilityStatusStatusChange(status: {
        availabilityStatus: string;
        available: boolean;
    }): void {
        const { availabilityStatus, available } = status;
        this.store!.dispatch(
            addAvailabilityStatus({
                timestamp: new Date().getTime(),
                available,
                status: availabilityStatus,
            })
        );
        this.logger.info('Availability status update', status);
    }
}
